export default __webpack_public_path__ + "static/media/returning-customers.c26308a5.svg";